// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"3afa280c","358":"e43065b7","453":"841296c2","524":"3a69f0b1","655":"e7eddddb","696":"7e1354df","790":"04fb2e4b","871":"17df15b6","929":"c1287e99","945":"f070664e"}[chunkId] + ".chunk.js";
};